export default __webpack_public_path__ + "static/media/0xcf32822ff397ef82425153a9dcb726e5ff61dca7.d0b75078.webp";